export const masterFormFields = {
    'addRetailerForm' : [
        {
            type: 'text',
            name: 'firstname',
            id: 'firstname',
            class: 'form-control',
            placeholder: 'Please enter first name',
            label: 'First Name',
            readOnly: false,
            required: true,
        },
        {
            type: 'text',
            name: 'lastname',
            id: 'lastname',
            class: 'form-control',
            placeholder: 'Please enter last name',
            label: 'Last Name',
            readOnly: false,
            required: true,
        },
        {
            type: 'text',
            name: 'retailer_name',
            id: 'retailer_name',
            class: 'form-control',
            placeholder: 'Please enter Retailer name',
            label: 'Retailer Name',
            readOnly: false,
            required: true,
        },
        {
            type: 'email',
            name: 'email',
            id: 'email',
            class: 'form-control',
            placeholder: 'Please enter email',
            label: 'Email',
            readOnly: false,
            required: true,
        },
        {
            type: 'password',
            name: 'password',
            id: 'password',
            class: 'form-control',
            placeholder: 'Please enter password',
            label: 'Password',
            readOnly: false,
            required: true,
        },
        {
            type: 'checkbox',
            name: 'status',
            id: 'status',
            class: 'form-check-input',
            placeholder: '',
            label: 'Check to Enable',
            readOnly: false
        }
    ],
    'editRetailerForm' : [
        {
            type: 'text',
            name: 'firstname',
            id: 'firstname',
            class: 'form-control',
            placeholder: 'Please enter first name',
            label: 'First Name',
            readOnly: false,
            required: true,
        },
        {
            type: 'text',
            name: 'lastname',
            id: 'lastname',
            class: 'form-control',
            placeholder: 'Please enter last name',
            label: 'Last Name',
            readOnly: false,
            required: true,
        },
        {
            type: 'text',
            name: 'retailer_name',
            id: 'retailer_name',
            class: 'form-control',
            placeholder: 'Please enter Retailer name',
            label: 'Retailer Name',
            readOnly: false,
            required: true,
        },
        {
            type: 'email',
            name: 'email',
            id: 'email',
            class: 'form-control',
            placeholder: 'Please enter email',
            label: 'Email',
            readOnly: true,
            required: true,
        },
        {
            type: 'checkbox',
            name: 'status',
            id: 'status',
            class: 'form-check-input',
            placeholder: '',
            label: 'Check to Enable',
            readOnly: false
        }
    ],
    'addProductTypeForm' : [
        {
            type: 'text',
            name: 'product_type_name',
            id: 'product_type_name',
            class: 'form-control',
            placeholder: 'Please enter Product Type name',
            label: 'Product Type Name',
            readOnly: false,
            required:true,
        },
        {
            type: 'checkbox',
            name: 'status',
            id: 'status',
            class: 'form-check-input',
            placeholder: '',
            label: 'Check to Enable',
            readOnly: false
        }
    ],
    'editProductTypeForm' : [
        {
            type: 'text',
            name: 'product_type_name',
            id: 'product_type_name',
            class: 'form-control',
            placeholder: 'Please enter Product Type name',
            label: 'Product Type Name',
            readOnly: false,
            required:true,
        },
        {
            type: 'checkbox',
            name: 'status',
            id: 'status',
            class: 'form-check-input',
            placeholder: '',
            label: 'Check to Enable',
            readOnly: false
        }
    ],
    'addManufacturerForm' : [
        {
            type: 'text',
            name: 'manufacturer_name',
            id: 'manufacturer_name',
            class: 'form-control',
            placeholder: 'Please enter Manufacturer Name',
            label: 'Manufacturer Name',
            readOnly: false,
            required:true,
        },
        {
            type: 'email',
            name: 'email',
            id: 'email',
            class: 'form-control',
            placeholder: 'Please enter Email',
            label: 'Email',
            readOnly: false,
            required:true,
        },
        {
            type: 'checkbox',
            name: 'status',
            id: 'status',
            class: 'form-check-input',
            placeholder: '',
            label: 'Check to Enable',
            readOnly: false
        }
    ],
    'editManufacturerForm' : [
        {
            type: 'text',
            name: 'manufacturer_name',
            id: 'manufacturer_name',
            class: 'form-control',
            placeholder: 'Please enter Manufacturer Name',
            label: 'Manufacturer Name',
            readOnly: false,
            required:true,
        },
        {
            type: 'email',
            name: 'email',
            id: 'email',
            class: 'form-control',
            placeholder: 'Please enter Email',
            label: 'Email',
            readOnly: false,
            required:true,
        },
        {
            type: 'checkbox',
            name: 'status',
            id: 'status',
            class: 'form-check-input',
            placeholder: '',
            label: 'Check to Enable',
            readOnly: false
        }
    ],
    'addInstallationTypeForm' : [
        {
            type: 'text',
            name: 'installation_type_name',
            id: 'installation_type_name',
            class: 'form-control',
            placeholder: 'Please enter Installation Type Name',
            label: 'Installation Type Name',
            readOnly: false,
            required:true
        },
        {
            type: 'checkbox',
            name: 'status',
            id: 'status',
            class: 'form-check-input',
            placeholder: '',
            label: 'Check to Enable',
            readOnly: false
        }
    ],
    'editInstallationTypeForm' : [
        {
            type: 'text',
            name: 'installation_type_name',
            id: 'installation_type_name',
            class: 'form-control',
            placeholder: 'Please enter Installation Type Name',
            label: 'Installation Type Name',
            readOnly: false,
            required:true
        },
        {
            type: 'checkbox',
            name: 'status',
            id: 'status',
            class: 'form-check-input',
            placeholder: '',
            label: 'Check to Enable',
            readOnly: false
        }
    ],
    'addLocationForm' : [
        {
            type: 'text',
            name: 'location_name',
            id: 'location_name',
            class: 'form-control',
            placeholder: 'Please enter Store Location name',
            label: 'Store Location Name',
            readOnly: false,
            required: true,
        },
        {
            type: 'text',
            name: 'addressone',
            id: 'addressone',
            class: 'form-control',
            placeholder: 'Please enter Address 1',
            label: 'Address 1',
            readOnly: false,
            required: true,
        },
        {
            type: 'text',
            name: 'addresstwo',
            id: 'addresstwo',
            class: 'form-control',
            placeholder: 'Please enter Address 2',
            label: 'Address 2',
            readOnly: false
        },
        {
            type: 'text',
            name: 'city',
            id: 'city',
            class: 'form-control',
            placeholder: 'Please enter City',
            label: 'City',
            readOnly: false,
            required: true,
        },
        {
            type: 'text',
            name: 'state',
            id: 'state',
            class: 'form-control',
            placeholder: 'Please enter State',
            label: 'State',
            readOnly: false,
            required: true,
        },
        {
            type: 'text',
            name: 'postal_code',
            id: 'postal_code',
            class: 'form-control',
            placeholder: 'Please enter Zip',
            label: 'Zip',
            readOnly: false,
            required: true,
        },
        {
            type: 'checkbox',
            name: 'status',
            id: 'status',
            class: 'form-check-input',
            placeholder: '',
            label: 'Check to Enable',
            readOnly: false
        }
    ],
    'editLocationForm' : [
        {
            type: 'text',
            name: 'location_name',
            id: 'location_name',
            class: 'form-control',
            placeholder: 'Please enter Store Location name',
            label: 'Store Location Name',
            readOnly: false,
            required: true,
        },
        {
            type: 'text',
            name: 'addressone',
            id: 'addressone',
            class: 'form-control',
            placeholder: 'Please enter Address 1',
            label: 'Address 1',
            readOnly: false,
            required: true,
        },
        {
            type: 'text',
            name: 'addresstwo',
            id: 'addresstwo',
            class: 'form-control',
            placeholder: 'Please enter Address 2',
            label: 'Address 2',
            readOnly: false
        },
        {
            type: 'text',
            name: 'city',
            id: 'city',
            class: 'form-control',
            placeholder: 'Please enter City',
            label: 'City',
            readOnly: false,
            required: true,
        },
        {
            type: 'text',
            name: 'state',
            id: 'state',
            class: 'form-control',
            placeholder: 'Please enter State',
            label: 'State',
            readOnly: false,
            required: true,
        },
        {
            type: 'text',
            name: 'postal_code',
            id: 'postal_code',
            class: 'form-control',
            placeholder: 'Please enter Zip',
            label: 'Zip',
            readOnly: false,
            required: true,
        },
        {
            type: 'checkbox',
            name: 'status',
            id: 'status',
            class: 'form-check-input',
            placeholder: '',
            label: 'Check to Enable',
            readOnly: false
        }
    ],
}
